'use client';

import { c } from '../../utils/tailwind-merge';
import { PublisherInfo } from '../PublisherInfo/PublisherInfo';
import { PublisherInfoTable } from '../PublisherInfoTable/PublisherInfoTable';
import { PublisherOverview } from '../PublisherOverview/PublisherOverview';
import { PublisherProfileTabs } from '../PublisherProfileTabs/PublisherProfileTabs';
import { Separator } from '../Separator/Separator';
import { SocialMediaTable } from '../SocialMediaTable/SocialMediaTable';
import { PublisherProfileTemplateProps } from './types';

export const PublisherProfileTemplate = ({
  tabs,
  overview,
  publisherInfo,
  publisherInfoTable,
  socialMedia,
  microcopy,
  className,
  renderPublisherAssets,
  onOpenCookieSettings,
}: PublisherProfileTemplateProps) => {
  const Desktop = () => (
    <section className="hidden pb-16 lg:block">
      <div className="lg-container w-full">
        <div className="grid grid-cols-[minmax(0,_1fr)_396px] items-start gap-6">
          <div className="flex min-w-0 flex-col gap-6 self-start">
            <PublisherOverview
              {...overview}
              onOpenCookieSettings={onOpenCookieSettings}
            />
          </div>
          <aside className="flex flex-col gap-6 lg:shrink-0">
            <PublisherInfo
              size="big"
              microcopy={microcopy.publisherInfo}
              {...publisherInfo}
            />
            <Separator />
            <PublisherInfoTable
              {...publisherInfoTable}
              microcopy={microcopy.publisherInfoTable}
              rightColumnTextAlign="left"
            />

            <SocialMediaTable
              microcopy={microcopy.socialMedia}
              {...socialMedia}
            />
          </aside>
        </div>
        <PublisherProfileTabs
          defaultValue="assets"
          {...tabs}
          microcopy={microcopy.tabs}
          renderPublisherAssets={renderPublisherAssets}
        />
      </div>
    </section>
  );

  const Mobile = () => (
    <section className={c('grid grid-cols-1 gap-6 px-4 pb-4 lg:hidden')}>
      <PublisherInfo
        size="big"
        microcopy={microcopy.publisherInfo}
        {...publisherInfo}
        className="mt-8"
      />
      <Separator className="my-2" />
      <PublisherInfoTable
        {...publisherInfoTable}
        microcopy={microcopy.publisherInfoTable}
        className="max-w-[710px]"
        rightColumnTextAlign="left"
      />
      <SocialMediaTable
        microcopy={microcopy.socialMedia}
        {...socialMedia}
        className="max-w-[710px]"
      />
      <PublisherOverview
        {...overview}
        onOpenCookieSettings={onOpenCookieSettings}
      />
      <PublisherProfileTabs
        defaultValue="assets"
        {...tabs}
        microcopy={microcopy.tabs}
        renderPublisherAssets={renderPublisherAssets}
      />
    </section>
  );

  return (
    <main className={className}>
      <Desktop />
      <Mobile />
    </main>
  );
};
